import { render, staticRenderFns } from "./ProcedimentosDetalhes.vue?vue&type=template&id=792b02b4&"
import script from "./ProcedimentosDetalhes.vue?vue&type=script&lang=js&"
export * from "./ProcedimentosDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ProcedimentosDetalhes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports